import React, { useContext } from 'react';
import InputMask from 'react-input-mask';
import { Field } from 'formik';
import { appendValidationClassNames } from './utils';
import { FormContext } from './FormContext';
/**
 * @param {maskedValue} if true will keep mask symbols like (012) 123-1233,
 *  if false will remove them and value will be like 0121231233
 */
const PhoneField = React.forwardRef((props, ref) => {
  const context = useContext(FormContext);
  const { disabled, readOnly } = context ? context : {};
  const extProps = { disabled, readOnly, ...props };

  const beforeMaskedValueChange = (newState) => {
    var { value } = newState;
    var selection = newState.selection;
    if (value === '(') value = '';
    return {
      value,
      selection
    };
  };

  return (
    <Field
      {...extProps}
      ref={ref}
      render={({ field, form: { touched, errors, setFieldValue } }) => {
        const classes = appendValidationClassNames(
          props.className,
          touched,
          errors,
          field.name
        );
        const handleChange = event => {
          let value = event.target.value;
          if (!props.maskedValue) {
            if (value && typeof value === 'string') {
              value = value.replace(/[()\- ]/g, '');
            }
          }
          setFieldValue(props.name, value);
          if (props.onChange && typeof props.onChange === 'function') {
            props.onChange({ target: { value: value } });
          }
        };

        return (
          <InputMask
            {...field}
            {...extProps}            
            placeholder="ex. (000) 000-0000"
            mask="(999) 999-9999"
            autoComplete={field.value ? 'new-password' : ''}
            maskChar={null}
            className={classes}
            alwaysShowMask={false}
            beforeMaskedValueChange={beforeMaskedValueChange}
            onChange={handleChange}
          />
        );
      }}
    />
  );
});

PhoneField.displayName = 'PhoneField';
export default PhoneField;
